import React, { useState, useEffect } from 'react';
import { Target, Handshake, TrendingUp } from 'lucide-react';
import { visionData } from '../mock';

const iconMap = {
  'Strategic focus': Target,
  'Partnership integrity': Handshake,
  'Operational excellence': TrendingUp
};

export const Vision = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    }, { threshold: 0.1 });

    const section = document.querySelector('#vision');
    if (section) observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="vision" className="section-padding" style={{ background: 'linear-gradient(180deg, var(--bg-secondary) 0%, var(--bg-primary) 100%)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '80px', opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(30px)', transition: 'all 0.8s ease' }}>
          <h2 className="heading-1">{visionData.title}</h2>
          <div className="gold-line" style={{ margin: '24px auto' }} />
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '40px' }}>
          {visionData.values.map((value, index) => {
            const Icon = iconMap[value.title];
            return (
              <div key={index} style={{ textAlign: 'center', padding: '40px 32px', background: 'var(--bg-primary)', border: '1px solid var(--border-light)', opacity: isVisible ? 1 : 0, transform: isVisible ? 'translateY(0)' : 'translateY(30px)', transition: `all 0.8s ease ${0.3 + index * 0.1}s`, position: 'relative', overflow: 'hidden' }}>
                <div style={{ width: '60px', height: '60px', border: '2px solid var(--accent-gold)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 24px' }}>
                  {Icon && <Icon size={32} color="var(--accent-gold)" />}
                </div>
                <h4 className="heading-3" style={{ marginBottom: '16px' }}>{value.title}</h4>
                <p className="body-regular" style={{ color: 'var(--text-secondary)', lineHeight: '1.7' }}>{value.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};